import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Persistent guest session id for cart / wishlist / orders
export function getSessionId() {
  let sid = localStorage.getItem("dfk_session");
  if (!sid) {
    sid = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("dfk_session", sid);
  }
  return sid;
}

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
